<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">

    <div class="vx-navbar-wrapper navbar-full p-0 rounded-none" :class="classObj">
      <vs-navbar class="hidden md:block navbar-custom navbar-skelton pt-4 md:pt-8 px-6" style="background: #f7f7f7">
        <div class="vx-row justify-between w-full" id="logo-container">

          <div class="vx-col md:w-1/2 lg:w-1/2 flex flex-start items-center text-left">
            <a :href="linkApp" target="_blank" class="cursor-pointer lg:mx-0 text-left flex items-center text-grey">
              <small class="mr-2">
                <feather-icon icon="SmartphoneIcon"></feather-icon>  
              </small>
              <small>Download ZX App</small>
            </a>
          </div>
          <div class="vx-col hidden md:block md:w-1/2 lg:w-1/2">
            <ul class="flex justify-end">
              <li class="mx-4"><router-link to="/about" class="text-grey"><small>Tentang ZX</small></router-link></li>
              <li class="mx-4"><router-link to="/sahabat-zx" class="text-grey"><small>Sahabat ZX</small></router-link></li>
              <li class="mx-4"><router-link to="/promo" class="text-grey"><small>Promo</small></router-link></li>
              <li class="mx-4"><router-link to="/zxcare" class="text-grey"><small>ZX Care</small></router-link></li>
            </ul>
          </div>

        </div>
      </vs-navbar>
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton bg-primary rounded-none" :color="navbarColorLocal" :class="textColor">

        <div class="flex items-center justify-between w-full">
          <!-- SM - OPEN SIDEBAR BUTTON -->
          <feather-icon class="text-white sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

          <router-link tag="div" to="/" class="vx-logo cursor-pointer mx-auto flex items-center">
            <img src="/assets/images/footer/logozx.svg" class="logo w-12 md:w-24 lg:w-24 md:py-2" alt=""  />
          </router-link>
          <div>
            <profile-drop-down />
          </div>
            
        </div>

      </vs-navbar>
    </div>
  </div>
</template>
<script>
import utils from '@/assets/utils/index'
import Bookmarks            from './components/Bookmarks.vue'
import CartDropDown         from './components/CartDropDown.vue'
import MessageDropDown      from './components/MessageDropDown.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'

export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    Bookmarks,
    CartDropDown,
    NotificationDropDown,
    MessageDropDown,
    ProfileDropDown
  },
  computed: {
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  }
}
</script>

